<button
  class="app-ui-toggle-button"
  [class.active]="active"
  (click)="setActive()"
>
  <ng-content></ng-content>
</button>
